import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import React from 'react';

type AutocompleteInputAdornmentProps = {
    onClick: () => void;
    disabled?: boolean;
    isAutocompleteOpen: boolean;
};

export const AutocompleteInputAdornment: React.FC<AutocompleteInputAdornmentProps> = ({
    onClick, disabled, isAutocompleteOpen,
}) => (
    <InputAdornment position="end">
        <IconButton
            disableRipple
            tabIndex={-1}
            onClick={onClick}
            disabled={disabled}
            style={{
                position: 'absolute',
                right: 0,
                backgroundColor: 'transparent',
            }}>
            {isAutocompleteOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown /> }
        </IconButton>
    </InputAdornment>
);
